import styled from 'styled-components';

import { Row } from '../Row';

export const StyledToggleSwitch = styled(Row)(
  ({ enabled, theme: { font, colors } }) => ({
    '&:after': {
      background: enabled ? colors.white : colors.grey,
      borderRadius: '100%',
      content: '""',
      height: 20,
      left: enabled ? 26 : 4,
      position: 'absolute',
      top: 3,
      transition: 'left ease 0.25s',
      width: 20,
    },
    alignItems: 'center',
    background: enabled ? colors.success : colors.white,
    border: `1px solid ${enabled ? colors.success : colors.grey}`,
    borderRadius: 50,
    color: enabled ? colors.white : colors.grey,
    cursor: 'pointer',
    flexShrink: 0,
    flexWrap: 'nowrap',
    fontSize: 8,
    fontWeight: font.weight.semibold,
    height: 28,
    justifyContent: enabled ? 'flex-start' : 'flex-end',
    padding: '0 6px',
    position: 'relative',
    textTransform: 'uppercase',
    transition: 'background-color ease 0.25s, border-color ease 0.25s',
    userSelect: 'none',
    width: 50,
  }),
);
